var option_webview_default = {
  "option": "MnJEi",
  "user_choice": "_9gJr2",
  "check": "RInyI",
  "image": "_0buzI",
  "input": "Z24BU",
  "title": "TBr2P",
  "centered": "G3gqu",
  "with_result": "tFBww",
  "list": "JXkop",
  "with_image": "S-6Ar",
  "progress": "uSsb5",
  "progress_value": "yR-Q3",
  "label": "buTgE",
  "cta": "b9ftC",
  "adornment_icon": "tKBlS",
  "remove": "grGyl",
  "removeButton": "mmJOl",
  "removeButtonIcon": "_-5sfA",
  "overlay": "gmcGp",
  "shown": "_76AiE",
  "dark": "mI12p",
  "spinner": "Inmtx",
  "spin": "ITjjm",
  "grid": "C3avc"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
